import { Map } from 'immutable'
import moment from 'moment'
import React from 'react'
import { getDateFormat } from '../../../../../../../lib/format'
import { RenderFormControl } from '../../FormControls/RenderFormControl'

export function DateRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id, meta },
  component,
  uid,
  setPage,
}) {
  const type = _.get(meta, 'field.type')
  let format = 'YYYY-MM-DD'
  if (type === 'date') {
    format = getDateFormat(_.get(meta, ['format', 'value'], 'YYYY-MM-DD'), 'YYYY-MM-DD')
  } else if (type === 'datetime') {
    format = getDateFormat(_.get(meta, ['format', 'value'], 'MM/DD/YYYY'))
  } else {
    format = 'YYYY-MM-DD'
  }
  const [min, max] = React.useMemo(() => {
    let min = 0
    let max = 0
    if (preFilteredRows.length) {
      min = moment(preFilteredRows[0].values[id]).valueOf()
      max = moment(preFilteredRows[0].values[id]).valueOf()
    }
    preFilteredRows.forEach((row) => {
      min = Math.min(moment(row.values[id]).valueOf(), min)
      max = Math.max(moment(row.values[id]).valueOf(), max)
    })
    if (_.isNaN(min)) {
      min = 0
    }
    if (_.isNaN(max)) {
      max = 0
    }
    if (min) {
      min = moment(min, 'x').utc().format(format)
    } else {
      min = ''
    }
    if (max) {
      max = moment(min, 'x').utc().format(format)
      if (min === max) {
        max = ''
      }
    } else {
      max = ''
    }
    return [min, max]
  }, [id, preFilteredRows])

  let minPlaceholder = component.getIn(['props', 'captions', 'Min'], 'Min')
  let maxPlaceholder = component.getIn(['props', 'captions', 'Max'], 'Max')

  let minStr = min ? `${minPlaceholder} (${min})` : minPlaceholder
  let maxStr = max ? `${maxPlaceholder} (${max})` : maxPlaceholder

  let filterValueStr = ''
  if (filterValue.length && (filterValue[0] || filterValue[1])) {
    if (moment(filterValue[0]).format('') !== 'Invalid date') {
      filterValueStr = moment(filterValue[0]).format(format)
    }
    if (moment(filterValue[1]).format('') !== 'Invalid date') {
      let formatValue = moment(filterValue[1]).format(format)
      if (formatValue !== filterValueStr) {
        filterValueStr = (filterValueStr ? filterValueStr + ' - ' : '') + formatValue
      }
    }
  }

  let customPlaceholder = `${minStr} - ${maxStr}`
  if (meta && meta.filterPlaceholder) {
    customPlaceholder = meta.filterPlaceholder
  }

  return (
    <RenderFormControl
      value={filterValueStr}
      filterValue={filterValue}
      type="daterange"
      onChange={(e) => {
        const val = e.target.value
        setFilter(val)
        if (e.target.value[0] || e.target.value[1]) {
          setPage(0)
        }
      }}
      allowClear
      placeholder={customPlaceholder}
      themeKey="PrjPowerTableFilterField"
      styleKey={`ft--${uid}`}
      captions={component.getIn(['props', 'captions'], Map())}
    />
  )
}
